import { LocalContentProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  LocalContentProps["options"],
  OptionalPropertyOf<LocalContentProps["options"]>
> = {
  zoom: 16,
  pitch: 0,
  bearing: 0,
  cooperativeGestures: true,
  distanceUnit: "metric",
  // TODO might need to revisit this
  hideScores: false,
  // TODO Might not need this
  collapseScores: false,
  scoresMenu: {
    defaultOpen: true,
    categories: {
      transport: {
        hide: false,
        order: 1,
        colors: {
          background: "#E9F8FA",
          fill: "#008491",
        },
        scores: {
          pedestrian_friendly: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          cycling_friendly: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          transit_friendly: {
            hide: false,
            hideScore: false,
            order: 3,
          },
          car_friendly: {
            hide: false,
            hideScore: false,
            order: 4,
          },
        },
      },
      education: {
        hide: false,
        order: 2,
        colors: {
          background: "#E4EFFF",
          fill: "#003548",
        },
        scores: {
          daycares: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          primary_schools: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          high_schools: {
            hide: false,
            hideScore: false,
            order: 3,
          },
        },
      },
      amenities: {
        hide: false,
        order: 3,
        colors: {
          background: "#FFF2C3",
          fill: "#BF8500",
        },
        scores: {
          shopping: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          groceries: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          restaurants: {
            hide: false,
            hideScore: false,
            order: 3,
          },
          cafes: {
            hide: false,
            hideScore: false,
            order: 4,
          },
        },
      },
      character: {
        hide: false,
        order: 4,
        colors: {
          background: "#FFDAAC",
          fill: "#FF7044",
        },
        scores: {
          nightlife: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          vibrant: {
            hide: false,
            hideScore: false,
            order: 2,
          },
          historic: {
            hide: false,
            hideScore: false,
            order: 3,
          },
          quiet: {
            hide: false,
            hideScore: false,
            order: 4,
          },
        },
      },
      nature: {
        hide: false,
        order: 5,
        colors: {
          background: "#D8F4D9",
          fill: "#0F766E",
        },
        scores: {
          parks: {
            hide: false,
            hideScore: false,
            order: 1,
          },
          greenery: {
            hide: false,
            hideScore: false,
            order: 2,
          },
        },
      },
      wellness: {
        hide: false,
        order: 6,
        colors: {
          background: "#FFE7FE",
          fill: "#FF84D6",
        },
        scores: {
          wellness: {
            hide: false,
            hideScore: false,
            order: 1,
          },
        },
      },
    },
  },
};

export default defaultState;
